import { render, staticRenderFns } from "./article-table.vue?vue&type=template&id=4025d9f5&scoped=true&"
import script from "./article-table.ts?vue&type=script&lang=ts&"
export * from "./article-table.ts?vue&type=script&lang=ts&"
import style0 from "./article-table.scss?vue&type=style&index=0&id=4025d9f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4025d9f5",
  null
  
)

export default component.exports